import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import TemplateLayout from '../../Commons/TemplateLayout';
import { useContext, useEffect, useLayoutEffect, useState } from 'react';
import {
  getProjectTemplateById,
  updateProjectTemplate,
} from '../../../../../../services/api/projectTemplates';
import { MainContext } from '../../../../../../context/MainContext';
import { useIntl } from 'react-intl';
import SuccessPage from '../../Commons/TemplateLayout/components/SuccessPage';
import { concreteTypes } from '../../../../../../constants/general';
import DeliveryFormFields from '../Commons/DeliveryFormFields';

const UpdateDeliveryTemplate = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { project } = useOutletContext();
  const { model, templateId } = useParams();
  const { setError, setLoading } = useContext(MainContext);
  const [success, setSuccess] = useState(false);
  const [template, setTemplate] = useState();
  const [regions, setRegions] = useState([]);
  const [initialData, setInitialData] = useState();

  const updateDeliveryTemplate = async (regions, formState, fileName) => {
    try {
      setLoading(true);
      const regionIndex = regions.findIndex((reg) => reg.data === 'CIF');
      const region = regions[regionIndex];
      regions.splice(regionIndex, 1);
      const updateToTemplate = {
        id: templateId,
        name: formState.templateName,
        supplier: formState.supplier_id,
        model,
        createdAt: template.createdAt,
        pid: template.pid,
        image: fileName.replace('pdf', 'png'),
        searchableRegion: {
          value: '',
          region: region,
        },
        regions: regions,
      };
      const updatedTemplate = await updateProjectTemplate(updateToTemplate);

      if (updatedTemplate.data) {
        setSuccess(true);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useLayoutEffect(() => {
    if (!concreteTypes.includes(model)) {
      navigate('/');
    }
  }, [model, navigate]);

  useEffect(() => {
    async function loadTemplate() {
      setLoading(true);
      const loadedTemplate = (await getProjectTemplateById({ id: templateId }))
        .data;
      loadedTemplate.regions.unshift(loadedTemplate.searchableRegion.region);
      setTemplate(loadedTemplate);
      setInitialData({
        templateName: loadedTemplate.name,
        supplier_id: loadedTemplate.supplier,
      });
      setRegions(
        loadedTemplate.regions.map((region, index) => ({
          ...region,
          index,
          isVisible: true,
        })),
      );
    }
    loadTemplate();
  }, [setLoading, templateId]);

  if (success) {
    return (
      <SuccessPage
        title={intl.formatMessage({
          id: 'pages.ocr.templates.delivery.edit.success.title',
        })}
        subtitle={intl.formatMessage({
          id: 'pages.ocr.templates.delivery.edit.success.subtitle',
        })}
        onBackToTemplates={() =>
          navigate(`/app/project/${project.id_project}/quality/ocr/templates`)
        }
      />
    );
  }
  return (
    <TemplateLayout
      topFormFields={<DeliveryFormFields editMode={true} />}
      model={model}
      initialData={initialData}
      regions={regions}
      onFinish={updateDeliveryTemplate}
      onBack={() =>
        navigate(`/app/project/${project.id_project}/quality/ocr/templates`)
      }
    />
  );
};

export default UpdateDeliveryTemplate;
